exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Ky49 {\n  width: 100%;\n  height: calc(100% - 53px);\n}\n", ""]);

// Exports
exports.locals = {
	"pdf": "_2Ky49"
};